import Vue from 'vue';
import VueRouter from 'vue-router';
import VueRouterReferer from '@tozd/vue-router-referer';

import HelloWorld from '../components/HelloWorld.vue';
import StockList from '../components/Stocks/StockList.vue';
import ProductForm from '../components/Products/ProductForm.vue';
import Dashboard from '../components/Admin/Dashboard.vue';
import DashboardMain from '../components/Admin/DashBoardMain.vue';
import DataTable from '../components/CRUDs/DataTable.vue';
import ProductList from '../components/Products/AllProducts/ShowProducts.vue';
import PreviewProduct from '../components/Products/Preview/PreviewProduct.vue';
import IngredientsTable from '../components/Products/Ingredients/IngredientsTable.vue';
import RolesTable from '../components/Products/Roles/RolesTable.vue';
import RelatedIncisTable from '../components/Products/RelatedIncis/RelatedIncisTable.vue';
import ManageUsers from '../components/Users/ManageUsers.vue';
import SegmentationManager from '../components/CRUDs/Segmentations/SegmentationManager.vue';
import ChildSegManagement from '../components/CRUDs/Segmentations/ChildSegmentationTable.vue';
import ManageExports from '../components/Admin/ManageExports.vue';

Vue.use(VueRouter);
Vue.use(VueRouterReferer);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HelloWorld,
    },
    {
      path: '/login',
      name: 'Login',
      component: HelloWorld,
      props: { view: 'login' },
    },
    {
      path: '/signup',
      name: 'Subscribe',
      component: HelloWorld,
      props: { view: 'subscribe' },
    },
    {
      path: '/password-reset',
      name: 'PasswordReset',
      component: HelloWorld,
      props: { view: 'forgotPassword' },
    },
    {
      path: '/dashboard',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'DashboardMain',
          components: {
            dashboardMain: DashboardMain,
          },
        },
        {
          path: 'resources/:name',
          components: {
            table: DataTable,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS'],
          },
        },
        {
          path: 'amoire-technique/',
          components: {
            table: SegmentationManager,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS', 'ROLE_RESEARCH'],
          },
          children: [
            {
              path: 'child-segmentations',
              components: {
                amoireTechnique: ChildSegManagement,
              },
              meta: {
                restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS', 'ROLE_RESEARCH'],
              },
              name: 'childSegmentations',
            },
            {
              path: ':name',
              components: {
                amoireTechnique: DataTable,
              },
              meta: {
                restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS', 'ROLE_RESEARCH'],
              },
            },
          ],
        },
        {
          path: 'manage-stock',
          name: 'StockList',
          components: {
            table: StockList,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS'],
          },
        },
        {
          path: 'manage-stock/product',
          name: 'ProductForm',
          props: (route) => ({ query: route.query.q }),
          components: {
            table: ProductForm,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS'],
          },
        },
        {
          path: 'manage-products',
          name: 'ProductList',
          components: {
            table: ProductList,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS', 'ROLE_MARKETING', 'ROLE_MARKETING_PLUS', 'ROLE_RESEARCH'],
          },
        },
        {
          path: 'manage-products/product',
          name: 'ProductFormExt',
          props: (route) => ({ query: route.query.q }),
          components: {
            table: ProductForm,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS', 'ROLE_RESEARCH'],
          },
        },
        {
          path: 'manage-products/product/preview',
          name: 'PreviewProduct',
          props: (route) => ({ query: route.query.q }),
          components: {
            table: PreviewProduct,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS', 'ROLE_MARKETING', 'ROLE_MARKETING_PLUS', 'ROLE_RESEARCH'],
            instruction: 'saveQuery',
          },
        },
        {
          path: 'manage-products/view/ingredients',
          name: 'IngredientsTable',
          // props: (route) => ({ query: route.query.q }),
          components: {
            table: IngredientsTable,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS', 'ROLE_MARKETING', 'ROLE_MARKETING_PLUS', 'ROLE_RESEARCH'],
            instruction: 'saveQuery',
          },
        },
        {
          path: 'manage-products/view/roles',
          name: 'RolesTable',
          // props: (route) => ({ query: route.query.q }),
          components: {
            table: RolesTable,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS', 'ROLE_MARKETING', 'ROLE_MARKETING_PLUS', 'ROLE_RESEARCH'],
            instruction: 'saveQuery',
          },
        },
        {
          path: 'manage-products/view/related-incis',
          name: 'RelatedIncisTable',
          // props: (route) => ({ query: route.query.q }),
          components: {
            table: RelatedIncisTable,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN', 'ROLE_ADMIN_PLUS', 'ROLE_MARKETING', 'ROLE_MARKETING_PLUS', 'ROLE_RESEARCH'],
            instruction: 'saveQuery',
          },
        },
        {
          path: 'admin/manage-users',
          name: 'ManageUsers',
          components: {
            table: ManageUsers,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN_PLUS'],
          },
        },
        {
          path: 'admin/manage-exports',
          name: 'ManageExports',
          components: {
            dashboardMain: ManageExports,
          },
          meta: {
            restrictedTo: ['ROLE_ADMIN_PLUS'],
          },
        },
      ],
    },
  ],
  mode: "history"
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js